import mrpHeadingStyle from '../mrp/heading'

export default {
  ...mrpHeadingStyle,
  loyaltyFontStyle: {
    fontWeight: 850,
    fontSize: '20px',
    lineHeight: '26px',
    'screen-large': {
      fontSize: '24px',
      lineHeight: '32px'
    }
  }
}
